import client from 'app/client';

export interface OperationResponse {
  isSuccess: boolean;
  errorMessage?: string;
  id?: string;
}

export interface PortefeuilleEntryDto {
  entryId: string;
  personneId: string;
  personneMoraleId?: string;
  designation?: string;
  numeroSiret?: string;
  addedAt: string;
  addedByAbpUserId: string;
  isPartnerPlateforme: boolean;
}

export interface GetPortefeuilleResponse {
  plateformeId: string;
  entries: PortefeuilleEntryDto[];
}

export interface EligiblePersonneMoraleDto {
  personneId: string;
  personneMoraleId: string;
  designation: string;
  numeroSiret?: string;
  ownedPlateformeId: string;
}

export interface EligibleChildPersonneMoraleDto {
  personneId: string;
  personneMoraleId: string;
  designation: string;
  numeroSiret?: string;
}

export async function getPortefeuille(
  plateformeId: string,
): Promise<GetPortefeuilleResponse> {
  const { data } = await client.get<GetPortefeuilleResponse>(
    `/backoffice/plateformes/${plateformeId}/portefeuille`,
  );
  return data;
}

export async function addToPortefeuille(
  plateformeId: string,
  personneId: string,
): Promise<OperationResponse> {
  const { data } = await client.post<OperationResponse>(
    `/backoffice/plateformes/${plateformeId}/portefeuille`,
    { personneId },
  );
  return data;
}

export async function removeFromPortefeuille(
  plateformeId: string,
  personneId: string,
): Promise<OperationResponse> {
  const { data } = await client.delete<OperationResponse>(
    `/backoffice/plateformes/${plateformeId}/portefeuille/${personneId}`,
  );
  return data;
}

export async function getEligiblePartners(
  plateformeId: string,
  searchString?: string,
): Promise<EligiblePersonneMoraleDto[]> {
  const { data } = await client.get<EligiblePersonneMoraleDto[]>(
    `/backoffice/plateformes/${plateformeId}/portefeuille/eligible-partners`,
    { params: searchString ? { searchString } : undefined },
  );
  return data ?? [];
}

export async function getEligibleChildren(
  plateformeId: string,
  searchString?: string,
): Promise<EligibleChildPersonneMoraleDto[]> {
  const { data } = await client.get<EligibleChildPersonneMoraleDto[]>(
    `/backoffice/plateformes/${plateformeId}/portefeuille/eligible-children`,
    { params: searchString ? { searchString } : undefined },
  );
  return data ?? [];
}
